/**
 * 找到包住编辑器的滚动容器
 */
export const findScrollContainer = (editor) => {
    if (!editor?.view?.dom) return null;
    let el = editor.view.dom.parentElement;
    while (el && el !== document.body) {
        const style = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(style.overflowY) || /(auto|scroll)/.test(style.overflow)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
};

/**
 * 把文档中的某个位置滚到可视区域
 * @param {object} editor tiptap 编辑器
 * @param {number} pos ProseMirror 位置
 * @param {object} [options]
 * @param {HTMLElement} [options.container] 滚动容器，不传则自动查找
 * @param {number} [options.offset] 目标距容器顶部的距离（px）
 * @param {'smooth'|'auto'} [options.behavior]
 */
export const scrollEditorToPos = (editor, pos, options = {}) => {
    if (!editor?.view) return;
    const { offset = 24, behavior = 'smooth' } = options;
    const container = options.container || findScrollContainer(editor);
    try {
        const coords = editor.view.coordsAtPos(pos);
        if (!coords) return;
        if (container) {
            const containerRect = container.getBoundingClientRect();
            const targetTop = coords.top - containerRect.top + container.scrollTop - offset;
            container.scrollTo({ top: Math.max(0, targetTop), behavior });
            return;
        }
        const dom = editor.view.domAtPos(pos)?.node;
        const element = dom instanceof Element ? dom : dom?.parentElement;
        element?.scrollIntoView?.({ behavior, block: 'start' });
    } catch (error) {
        // 位置失效时忽略
    }
};
